import { Button, CircularProgress } from "@mui/material";
import { useState } from "react";
import { IconSupport } from "Icons";
import { withApiContext } from "context";

const SupportButton = (props) => {
  const { ticket, ctx_api, onSuccess, uMemberId } = props;
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false); // new success state

  const handleClick = async () => {
    setLoading(true);
    setSuccess(false);

    try {
      const response = await ctx_api.privateRequest({
        cmd: "escalate_to_support",
        args: { 
          ticket,
          uMemberId
        },
      });

      if (response?.message) {
        console.log(response.message);
        alert(response.message);
      }

      if (onSuccess) onSuccess(ticket.ticket_id);

      // show success for a short time
      setSuccess(true);
      setTimeout(() => setSuccess(false), 1500); // 1.5s success display
    } catch (error) {
      console.error("Failed to escalate to support:", error);
      alert("Failed to escalate ticket.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button
      variant="contained"
      startIcon={
        loading ? (
          <CircularProgress size={18} color="inherit" />
        ) : success ? (
          "✅"
        ) : (
          <IconSupport />
        )
      }
      onClick={handleClick}
      disabled={loading || props.disabled}
      sx={{
        maxHeight: { xs: 18, sm: 22, md: 28 },
        borderRadius: "10px",
        fontSize: { xs: "0.65rem", sm: "0.7rem", md: "0.75rem" },
        bgcolor: success ? "#4caf50" : "#20A6D2", // green on success
        "&:hover": { bgcolor: success ? "#43a047" : "#1c95bc" },
        textTransform: "none",
        transition: "background-color 0.3s",
      }}
    >
      {loading ? "Sending..." : success ? "Dev Support" : "Dev Support"}
    </Button>
  );
};

export default withApiContext(SupportButton);
